import { Button, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import apiService from "../../services/api-service";
import { tenant } from "../../tenant";
import showToast from "../../utils/toast";
import GenericForm from "../genericForm";
import GenericTable from "../genericTable";
// GraphQL import removed - now using REST API
import HourAdd from "./hourAdd";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import FlagIcon from "@mui/icons-material/Flag";
import { CircleIcon } from "lucide-react";
import { CircleNotificationsRounded } from "@mui/icons-material";
import { Circle } from "@mui/icons-material";

const HeaderWithLayer = ({ code, description }) => {
	const [open, setOpen] = useState(false);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<>
			<div>
				{code}
				<br />
				<span style={{ fontWeight: "200 !important" }}>{description.slice(0, 20) + (description.length > 20 ? "..." : "")}</span>
				{description.length > 20 && (
					<button
						onClick={handleOpen}
						style={{
							background: "none",
							border: "none",
							color: "#007BFF",
							cursor: "pointer",
							marginLeft: "5px",
							textDecoration: "underline",
							fontSize: "0.9rem",
						}}
					>
						Mostra tutto
					</button>
				)}
			</div>

			{/* Dialog per mostrare l'intera descrizione */}
			<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
				<DialogTitle>Descrizione Completa</DialogTitle>
				<DialogContent>
					<p>{description}</p>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} variant="contained" color="primary">
						Chiudi
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default function HourDetail(props) {
	const [columnsConfig, setColumnsConfig] = useState([]);
	const [appealData, setAppealData] = useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [job] = useState({});
	const [suppliersOption, setSuppliersOption] = useState([]);
	const [originalAppealData, setOriginalAppealData] = useState([]);
	const [selectedSuppliers, setSelectedSuppliers] = useState([]);

	const handleSetNotification = useCallback((msg, severityType) => {
		showToast(msg, severityType);
	}, []);

	const fetchAppeal = useCallback(() => {
		apiService
			.get(
				"/activity-management/",
				{
					id_area: localStorage.getItem("areaSelected"),
					date: dayjs(props?.date).format("YYYY-MM-DD"),
					from_appeal_journal_screen: false,
					get_all_hours: true,
				},
				{}
			)
			.then((data) => {
				setAppealData(data);
				setOriginalAppealData(data);
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #004535",
					"error"
				)
			);
	}, [props?.date, handleSetNotification]);

	console.log("appealData", appealData);
	function calculateTotalHours(user) {
		// Calculate total hours using reduce instead of forEach
		let totalHours = Object.entries(user).reduce((sum, [key, value]) => {
			if (key.startsWith("daily_job-")) {
				return sum + parseFloat(value) || 0;
			}
			return sum;
		}, 0);

		return totalHours;
	}

	useEffect(() => {
		apiService
			.get("/suppliers-management/", {}, {})
			.then((data) => {
				if (data) setSuppliersOption([...data, { id: -1, name: "Interno" }]);
			})
			.catch((error) => {
				console.log(error);
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento dei fornitori. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0000843",
					"error"
				);
			});
	}, [handleSetNotification]);

	const filter = (filters) => {
		// Se filters è vuoto, ritorna l'intera lista userOption
		let apply = true;
		if (Object.keys(filters).length === 0) apply = false;
		//console.log("filter", filters)

		const filteredData = originalAppealData.filter((row) => {
			return Object.keys(filters).every((key) => {
				const values = filters[key];

				// Se values è vuoto o nullo, consideriamo la condizione soddisfatta (non filtriamo)
				if (!values || values.length === 0) return true;

				// Verifica che il valore di row[key] sia presente nell'array filters[key]
				return values.includes(row[key]);
			});
		});

		if (apply) {
			setAppealData(filteredData);
		} else {
			setAppealData(originalAppealData);
		}
	};

	useEffect(() => {
		if (props?.date) {
			fetchAppeal();
			apiService
				.get(
					"/activity-management/",
					{
						id_area: localStorage.getItem("areaSelected"),
						date: dayjs(props?.date).format("YYYY-MM-DD"),
						get_headers_hours_detail: true,
					},
					{ Authorization: "Bearer " + localStorage.getItem("token") }
				)
				.then((data) => {
					let dailyJobs = data;
					//console.log('Risultati dell\'API:', data);
					if (!dailyJobs.length) {
						console.error("dailyJobs vuoto");
						return;
					}
					let initialState = [
						{
							accessorKey: "name",
							header: "Nome - Cognome",
							size: 30,
						},
						{
							accessorKey: "supplier_name",
							header: "Fornitore",
							size: 30,
						},
					];

					const status = [
						{
							accessorKey: "hours_to_insert",
							header: "Ore",
							size: 5,
							Cell: ({ cell }) => {
								const userData = cell.row.original;
								let totalHours = calculateTotalHours(userData);

								const isOverLimit = totalHours > userData.hours_to_insert;
								const isComplete = userData.hours_to_insert - totalHours === 0;

								return (
									<Box
										sx={{
											display: "flex",
											justifyContent: "start",
											alignItems: "center",
										}}
									>
										<Circle
											sx={{
												color: isComplete ? "green" : "red",
												fontSize: 32,
												marginRight: "10px",
											}}
										/>
										{totalHours} / {userData.hours_to_insert}
									</Box>
								);
							},
						},
					];

					let fatherDailyJobs = [];
					for (let i = 0; i < dailyJobs.length; i++) {
						fatherDailyJobs.push({
							id: `id_job_${dailyJobs[i]?.id}`, // Add a unique id for each column
							accessorKey: `${dailyJobs[i]?.id}`,
							header: <HeaderWithLayer code={dailyJobs[i]?.code} description={dailyJobs[i]?.description} />,
							size: 100,
							Cell: ({ cell }) => {
								return (
									<TextField
										id={`job-${dailyJobs[i]?.id}`}
										label="Ore"
										type="number"
										InputLabelProps={{
											shrink: true,
										}}
										value={cell.row.original[`${dailyJobs[i]?.id}`]}
										onChange={(e) => {
											const value = e.target.value;
											const index = cell.row.index; // Indice della riga nella tabella
											const columnKey = `${dailyJobs[i]?.id}`; // Chiave generata dinamicamente

											setAppealData((prevData) => {
												// Copia immutabile dei dati
												const updatedData = [...prevData];
												if (updatedData[index]) {
													updatedData[index][columnKey] = value;
												}
												return updatedData; // Restituisci lo stato aggiornato
											});
										}}
									/>
								);
							},
						});
					}
					setColumnsConfig([...initialState, ...fatherDailyJobs, ...status]);
				})
				.catch((error) => {
					console.log(error);
					handleSetNotification(
						"Qualcosa è andato storto durante il caricamento delle presenze. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #44637439",
						"error"
					);
				});
		}
	}, [props?.date]);

	useEffect(() => {
		if (JSON.stringify(job) !== JSON.stringify({})) setOpenDialog(true);
	}, [job]);

	return (
		<>
			<Dialog
				sx={{
					"& .MuiDialog-paper": {
						width: "580px",
						minHeight: "300px",
					},
				}}
				open={openDialog}
				onClose={() => setOpenDialog(false)}
			>
				<HourAdd job={job} data={appealData} setData={setAppealData} />
			</Dialog>

			<MDBox sx={{ marginBottom: "20px" }}>
				<MDTypography
					variant="h6"
					sx={{
						textAlign: "center",
						marginBottom: "10px",
					}}
				>
					Filtra operatori per fornitore
				</MDTypography>
				<MDBox
					sx={{
						display: "flex",
						border: "1px solid #1976d2",
						borderRadius: "10px",
						padding: "15px",
						overflowX: "auto",
						gap: "10px",
						"&::-webkit-scrollbar": {
							height: "8px",
						},
						"&::-webkit-scrollbar-track": {
							backgroundColor: "#f1f1f1",
							borderRadius: "4px",
						},
						"&::-webkit-scrollbar-thumb": {
							backgroundColor: "#888",
							borderRadius: "4px",
						},
						"&::-webkit-scrollbar-thumb:hover": {
							backgroundColor: "#555",
						},
					}}
				>
					{suppliersOption.map((supplier, i) => (
						<Button
							key={i}
							variant={selectedSuppliers.includes(supplier.id) ? "contained" : "outlined"}
							color="primary"
							sx={{
								minWidth: "120px",
								whiteSpace: "nowrap",
								backgroundColor: selectedSuppliers.includes(supplier.id) ? "#1976d2" : "#ffffff",
								color: selectedSuppliers.includes(supplier.id) ? "#ffffff" : "#1976d2",
								borderColor: "#1976d2",
								"&:hover": {
									backgroundColor: selectedSuppliers.includes(supplier.id) ? "#1565c0" : "#f5f5f5",
								},
								textWrap: "wrap",
							}}
							onClick={() => {
								const newSelectedSuppliers = selectedSuppliers.includes(supplier.id)
									? selectedSuppliers.filter((id) => id !== supplier.id)
									: [...selectedSuppliers, supplier.id];
								setSelectedSuppliers(newSelectedSuppliers);
								filter({ supplier: newSelectedSuppliers });
							}}
						>
							{supplier.name}
						</Button>
					))}
				</MDBox>
			</MDBox>

			<GenericTable
				authModelName="USERAPPEAL"
				disableButton={true}
				columns={columnsConfig}
				data={appealData}
				enableColumnFilterModes={false}
				showColumnFiltersInitially={false}
				enableRowSelection={false}
				enableSorting={false}
				enableColumnActions={false}
				sortingKey={null}
			/>

			<div
				style={{
					display: "flex",
					justifyContent: "end",
					alignItems: "center",
					gap: "10px",
					marginTop: "20px",
				}}
			>
				<Button
					variant="contained"
					color="primary"
					sx={{
						backgroundColor: "#514f4f",
						color: "white!important",
						width: "220px",
						height: "50px",
						fontSize: "16px",
					}}
					onClick={() => {
						apiService
							.post(
								"/activity-management/",
								{},
								{
									id_area: localStorage.getItem("areaSelected"),
									date: dayjs(props?.date).format("YYYY-MM-DD"),
									jobs: appealData,
									from_journal_activity_screen: true,
								}
							)
							.then((data) => {
								handleSetNotification("Operazione effettuata con successo", "success");
								fetchAppeal();
							})
							.catch((error) => {
								handleSetNotification(
									"Errore durante l'operazione. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #0056320271563080",
									"error"
								);
							});
					}}
				>
					Salva
				</Button>

				<Button
					variant="contained"
					color="primary"
					sx={{
						backgroundColor: "#514f4f",
						color: "white!important",
						width: "220px",
						height: "50px",
						fontSize: "16px",
					}}
					onClick={() => props.nextTab()}
				>
					Prossima scheda
				</Button>
			</div>
		</>
	);
}
